/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-parallax.js
 *
 * スクロールに合わせて実行するパララックスアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


gsap.config({
	//		autoSleep: 60,
	//		force3D: false,
	nullTargetWarn: false,
	//		trialWarn: false,
});

/**
 * パララックス - テキスト
 * スクロールに合わせて実行するパララックス
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setparallaxText = () => {

	// setparallaxText_X()
	setparallaxText_Y()

	/**
	 * X軸
	 */
	function setparallaxText_X() {
		const parallaxText_X = document.querySelectorAll(".parallax-text-X");
		gsap.set(parallaxText_X, {
			xPercent: 15,
		});
		gsap.registerEffect({
			name: "parallaxText_X",
			effect: (targets, config) => {
				return gsap.to(targets, {
					yPercent: -15,
					scrollTrigger: {
						trigger: targets,
						start: "top bottom",
						end: "bottom top",
						scrub: 1,
						//  markers: true,
					},
				});
			},
		});

		document.querySelectorAll(".parallax-text-X").forEach(function(point) {
			gsap.effects.parallaxText_X(point);
		});
	}

	/**
	 * Y軸
	 */
	function setparallaxText_Y() {
		const parallaxText_Y = document.querySelectorAll(".parallax-text-Y");
		gsap.set(parallaxText_Y, {
			yPercent: 15,
		});
		gsap.registerEffect({
			name: "parallaxText_Y",
			effect: (targets, config) => {
				return gsap.to(targets, {
					yPercent: -30,
					scrollTrigger: {
						trigger: targets,
						start: "top bottom",
						end: "bottom top",
						scrub: 2,
						// markers: true,
					},
				});
			},
		});

		document.querySelectorAll(".parallax-text-Y").forEach(function(point) {
			gsap.effects.parallaxText_Y(point);
		});
	}

};

/**
 * パララックス - img
 * スクロールに合わせて実行するパララックス
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setparallaxImg = () => {

	//  setparallaxImg_X()
	setparallaxImg_Y()

	/**
	 * X軸
	 */
	function setparallaxImg_X() {
		const parallaxImg_X = document.querySelectorAll(".parallax-img-X");
		gsap.set(parallaxImg_X, {
			xPercent: 15,
		});
		gsap.registerEffect({
			name: "parallaxImg_X",
			effect: (targets, config) => {
				return gsap.to(targets, {
					yPercent: -15,
					scrollTrigger: {
						trigger: targets,
						start: "top bottom",
						end: "bottom top",
						scrub: 1,
						//  markers: true,
					},
				});
			},
		});

		document.querySelectorAll(".parallax-img-X").forEach(function(point) {
			gsap.effects.parallaxImg_X(point);
		});
	}

	/**
	 * Y軸
	 */
	function setparallaxImg_Y() {
		const parallaxImg_Y = document.querySelectorAll(".parallax-img-Y");
		gsap.set(parallaxImg_Y, {
			yPercent: 15,
		});
		gsap.registerEffect({
			name: "parallaxImg_Y",
			effect: (targets, config) => {
				return gsap.to(targets, {
					yPercent: -15,
					scrollTrigger: {
						trigger: targets,
						start: "top bottom",
						end: "bottom top",
						scrub: 1,
						//  markers: true,
					},
				});
			},
		});

		document.querySelectorAll(".parallax-img-Y").forEach(function(point) {
			gsap.effects.parallaxImg_Y(point);
		});
	}

};

/**
 *  Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setparallaxText, setparallaxImg };